import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | AI-labbet</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to AI-labbet's homepage to explore our AI strategy, governance, and skilling services." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center bg-background px-4">
          <div className="text-center max-w-md">
            <h1 className="mb-4 text-6xl font-bold text-primary">404</h1>
            <p className="mb-2 text-2xl font-semibold text-foreground">Page Not Found</p>
            <p className="mb-8 text-muted-foreground">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <Button variant="primary" asChild size="lg">
              <Link to="/">Return to Home</Link>
            </Button>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
